import request from "../helpers/request";
import config from "../settings";
import { formatObject } from "./utility";
import createNotification from "../components/notification";


const defaultOptions = { credentials: "same-origin", headers: {} };
const methodsWithPayload = ["POST", "PUT", "PATCH", "DELETE"];
const API_URL = `${config.baseUrl}/api`;

/* eslint-disable no-underscore-dangle */
function _apiCall(path, options = {}) {
  const defaultedOptions = Object.assign({}, defaultOptions, options);

  if (
    methodsWithPayload.indexOf(defaultedOptions.method) > -1 &&
    defaultedOptions.body
  ) {
    defaultedOptions.headers["Content-Type"] = "application/json";
    defaultedOptions.body =
      typeof defaultedOptions.body === "string"
        ? defaultedOptions.body
        : JSON.stringify(defaultedOptions.body);
  }
  if (defaultedOptions.auth) {
    defaultedOptions.headers.Authorization = `Bearer ${getUserAuthToken()}`;
  }

  let defaultedPath = typeof path === "string" ? path : path.join("/");
  defaultedOptions.body =
    typeof defaultedOptions.body === "string"
      ? defaultedOptions.body
      : JSON.stringify(defaultedOptions.body);
  if (defaultedOptions.params) {
    const esc = encodeURIComponent;
    const query = Object.keys(defaultedOptions.params)
      .map((k) => `${esc(k)}=${esc(defaultedOptions.params[k])}`)
      .join("&");
    defaultedPath = `${defaultedPath}?${query}`;
  }

  return request(`${API_URL}/${defaultedPath}`, defaultedOptions).then(
    (result) => result
  );
}

export function getUserAuthToken() {
  return localStorage.getItem("id_token");
}

export function getObotToken(){
  return localStorage.getItem("obotAccessToken");
}

function uploadRequest(path, options) {
  const defaultedOptions = {
    credentials: "same-origin",
    headers: {},
    ...options,
  };
  // const defaultedOptions = Object.assign({}, defaultOptions, options);
  if (defaultedOptions.auth) {
    defaultedOptions.headers.Authorization = `Bearer ${getUserAuthToken()}`;
  }
  defaultOptions.headers.Connection = "Keep-Alive";
  defaultOptions.headers["Cache-Control"] = "no-cache";
  let defaultedPath = typeof path === "string" ? path : path.join("/");

  if (defaultedOptions.params) {
    const esc = encodeURIComponent;
    const query = Object.keys(defaultedOptions.params)
      .map((k) => `${esc(k)}=${esc(defaultedOptions.params[k])}`)
      .join("&");
    defaultedPath = `${defaultedPath}?${query}`;
  }
  defaultedOptions.timeout = 0

  return request(`${API_URL}/${defaultedPath}`, defaultedOptions).then(
    (result) => result
  );
}

function makeRequest(method, url, file) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open(method, url);
    xhr.setRequestHeader("Content-Type", "application/json");
    // xhr.setRequestHeader('Cache-Control', 'public,max-age=3600');
    xhr.setRequestHeader("Authorization", `Bearer ${getUserAuthToken()}`);
    xhr.onload = function() {
      if (this.status >= 200 && this.status < 300) {
        // let data = url;
        resolve(JSON.parse(xhr.response));
      } else {
        let message = "";
        try {
          const parse = JSON.parse(xhr.response);
          if (parse && parse.error == "Invalid token") {
            window.location.replace("/signin");
            createNotification(
              "error",
              "Session timed out. Please login again"
            );
          }
          else if (parse.error && Array.isArray(parse.message))
            message = parse?.message[0];
          else if (parse.errors && Array.isArray(parse.errors))
            message = parse?.errors[0]?.message;
          else if (parse.error && typeof parse.error === "string")
            message = parse?.error;
          else if (parse.data && parse.data.error && parse.data.error.message)
          message = parse.data.error.message;
          else if (parse.errors[0].errors[0].errors[0].message);
          message = parse.errors[0].errors[0].errors[0].message;
        } catch (error) {
          console.log(error);
          if (error && error.error == "Invalid token") {
            window.location.replace("/signin");
            createNotification(
              "error",
              "Session timed out. Please login again"
            );
          }
        }
        reject({
          status: this.status,
          error: { message },
        });
      }
    };

    xhr.onerror = function() {
      reject({
        status: this.status,
        statusText: xhr.statusText,
      });
    };

    xhr.send(file);
  });
}

let callId = 0;
export const call =
  process.env.NODE_ENV === "production"
    ? (path, options = {}, json = true, ...rest) => {
        callId += 1;
        const thisCallId = callId;
        return _apiCall(path, options, json, ...rest).then(
          (result) => {
            return result;
          },
          (error) => {
            if (error && error.error === "Invalid token") {
              window.location.replace("/signin");
              createNotification(
                "error",
                "Session timed out. Please login again"
              );
            }
            throw error;
          }
        );
      }
    : (path, options = {}, json = true, ...rest) => {
        callId += 1;
        const thisCallId = callId;
        /* eslint-disable no-console */

        return _apiCall(path, options, json, ...rest).then(
          (result) => {
            return result;
          },
          (error) => {
            if (error && error.error === "Invalid token") {
              window.location.replace("/signin");
              createNotification(
                "error",
                "Session timed out. Please login again"
              );
            }

            throw error;
          }
        );
        /* eslint-enable no-console */
      };

export default {
  auth: {
    login(payload) {
      return call(["auth", "admin", "login"], {
        method: "POST",
        body: payload,
      });
    },
    logout() {
      return call(["auth", "signout"], {
        method: "GET",
        auth: true,
      });
    },
  },
  reports:{
    analytics(payload){
      return call(["admin", "reports", "analytics"], {
        method: "GET",
        params: payload
      })
    }
  },
  area: {
    tableList(payload = {}) {
      return call(["admin", "tech-support", "category"], {
        method: "GET",
        auth: true,
        params: payload,
      });
    },
    add(payload) {
      return call(["admin", "tech-support", "category"], {
        method: "POST",
        body: payload,
        auth: true,
      });
    },
    delete(ticketAreaId) {
      return call(["admin", "ticketArea", "v2", ticketAreaId], {
        method: "DELETE",
        auth: true,
      });
    },
    update(payload) {
      return call(["admin", "ticketArea", "v2"], {
        method: "PATCH",
        body: payload,
        auth: true,
      });
    },
  },
  type: {
    tableList(payload = {}) {
      return call(["admin", "tech-support", "category"], {
        method: "GET",
        auth: true,
        params: payload,
      });
    },
    add(payload) {
      return call(["admin", "tech-support", "category"], {
        method: "POST",
        body: payload,
        auth: true,
      });
    },
    delete(ticketAreaId) {
      return call(["admin", "tech-support", "category", ticketAreaId], {
        method: "DELETE",
        auth: true,
      });
    },
    update(payload) {
      return call(["admin", "tech-support", "category"], {
        method: "PATCH",
        body: payload,
        auth: true,
      });
    },
  },
  common: {
    listOrganization() {
      return call(["admin", "organizations", "all"], {
        method: "GET",
        auth: true,
      });
    },
    classroomStudentList(payload = {}) {
      return call(["user"], {
        method: "GET",
        auth: true,
        params: payload,
      });
    },
    fetchHashTags(qs) {
      return call(["admin", "hashtags"], {
        method: "GET",
        auth: true,
        params: {
          search: qs,
        },
      });
    },
    defaultLogo() {
      return call(["admin", "default-logo"], {
        method: "GET",
        auth: true,
      });
    },
    fetchFields(payload) {
      return call(["admin", "settings"], {
        method: "GET",
        auth: true,
        ...(payload ? { params: payload } : null),
      });
    },
    updateSettings(payload) {
      return call(["admin", "settings"], {
        method: "PATCH",
        auth: true,
        body: payload,
      });
    },
    updateAdminSettings(payload) {
      return call(["admin", "settings", "superAdminSettings"], {
        method: "PATCH",
        auth: true,
        body: payload,
      });
    },
    fetchAdminSettings() {
      return call(["admin", "settings", "adminSettings"], {
        method: "GET",
        auth: true,
      });
    },
    schools() {
      return call(["admin", "schools", "all"], {
        method: "GET",
        auth: true,
      });
    },
    allClassrooms() {
      return call(["admin", "classroom", "all"], {
        method: "GET",
        auth: true,
      });
    },
    classrooms(payload) {
      return call(["admin", "classrooms"], {
        method: "GET",
        auth: true,
        ...(payload
          ? {
              params: payload,
            }
          : {}),
      });
    },
    organizationSchools(organization_id) {      
      return call(["admin", "schools","all"], {
        method: "GET",
        auth: true,
        params: organization_id
          ? {
              [Array.isArray(organization_id) ? 'organizations' : 'organization']: organization_id?.toString(),
            }
          : {},
      });
    },
    courseOrganizations() {
      return call(["admin", "organizations", "all", "names"], {
        method: "GET",
        auth: true,
      });
    },
    organizationCourses(organization_id) {
      return call(["admin", "course"], {
        method: "GET",
        auth: true,
        params: organization_id
          ? {
              organization: organization_id,
            }
          : {},
      });
    },
    teachers(params) {
      return call(["admin", "user"], {
        method: "GET",
        auth: true,
        params: formatObject(params),
      });
    },
    students(id) {
      let params = id ? { school: id } : {};
      return call(["admin", "students", "all"], {
        method: "GET",
        auth: true,
        params,
      });
    },
    subjects() {
      return call(["admin", "subject"], {
        method: "GET",
        auth: true,
      });
    },
    grades() {
      return call(["admin", "grade"], {
        method: "GET",
        auth: true,
      });
    },
    roles() {
      return call(["admin", "roles"], {
        method: "GET",
        auth: true,
      });
    },
    classrooms(payload) {
      return call(["admin", "classrooms"], {
        method: "GET",
        auth: true,
        ...(payload
          ? {
              params: payload,
            }
          : {}),
      });
    },
    import(payload, type) {
      return uploadRequest(["admin", "bulk", "import", type], {
        method: "POST",
        body: payload,
        auth: true,
      });
      // return uploadRequest("POST", `${API_URL}/admin/bulk/import/${type}`, payload);
    },
    encrypt(payload) {
      return makeRequest("POST", `${API_URL}/admin/custom/encrypt/`, payload);
    },
    saveDoe(payload) {
      return makeRequest("POST", `${API_URL}/admin/doe`, payload);
    },
    getDoe() {
      return call(["admin", "custom", "doe"], {
        method: "GET",
        auth: true,
      });
    },
  },
  units: {
    update(payload, unitId) {
      return call(["admin", "courses", "unit", unitId], {
        method: "PATCH",
        body: payload,
        auth: true,
      });
    },
    list(params) {
      return call(["admin", "my-classroom", "course", "lesson", params?.course, params?.classroom], {
        method: "GET",
        auth: true,
        params,
      });
    },
    addExistingLesson(body,id) {
      return call(["admin", "my-classroom", "unit", "lesson", "allocate", id], {
        method: "POST",
        body,
        auth: true,
      });
    },
  },
  dashboard: {
    list(body) {
      return call(["admin", "dashboard"], {
        method: "POST",
        body,
        auth: true,
      });
    },
    list1(params) {
      return call(["admin", "dashboard"], {
        method: "GET",
        params,
        auth: true,
      });
    },
    listLoggedUser(dateset) {
      return call(["admin", "dashboard", "teacher", "users-login-details"], {
        method: "GET",
        auth: true,
        params: dateset ? dateset : {},
      });
    },
    lessons(dateset) {
      return call(["admin", "dashboard", "teacher", "lessons-completion"], {
        method: "POST",
        auth: true,
        body: dateset ? dateset : undefined,
      });
    },

    classroom(payload) {
      return call(["admin", "classroom", "info"], {
        method: "POST",
        body: {
          classrooms: payload,
        },
      });
    },
    topHashtags() {
      return call(["admin", "dashboard", "parent", "top-hashtags"], {
        method: "GET",
        auth: true,
      });
    },
    topWebPlatforms() {
      return call(["admin", "dashboard", "parent", "top-webplatforms"], {
        method: "GET",
        auth: true,
      });
    },
  },
  DashboardParent: {
    fetchclubprogress(payload) {
      return call(["admin", "dashboard", "parent", "clubs-progress"], {
        method: "POST",
        body: payload,
      });
    },

    fetchclassprogress(payload) {
      return call(["admin", "dashboard", "parent", "classrooms-progress"], {
        method: "POST",
        body: {
          startDate: payload.from,
          endDate: payload.to,
          classrooms: payload.classrooms ? payload.classrooms : [],
          student: payload?.students || "",
          lessons: payload.lessons,
          weeks: payload.weeks,
        },
      });
    },
    topHashtags(payload) {
      if (!payload?.hashtag?.length) delete payload.hashtag;
      return call(["admin", "dashboard", "parent", "top-hashtags"], {
        method: "POST",
        body: {
          startDate: payload.from,
          endDate: payload.to,
          classrooms: payload.classrooms,
          student: payload?.students || "",
          lessons: payload.lessons,
          limit: payload?.limit,
          days: payload?.days,
          hashtags: payload?.hashtag,
        },
      });
    },
    myTopHashtags(payload) {
      if (!payload?.hashtag?.length) delete payload.hashtag;
      return call(["admin", "dashboard", "parent", "my-top-hashtags"], {
        method: "POST",
        body: {
          student: payload?.students || "",
          limit: payload?.limit,
          days: payload?.days,
          hashtags: payload?.hashtag,
        },
      });
    },

    lessonhashtagData(payload) {
      if (!payload?.hashtag?.length) delete payload.hashtag;
      return call(["admin", "dashboard", "parent", "top-lesson-hashtags"], {
        method: "POST",
        body: {
          startDate: payload.from,
          endDate: payload.to,
          classrooms: payload.classrooms,
          student: payload?.students || "",
          lessons: payload.lessons,
          limit: payload?.limit,
          days: payload?.days,
          hashtags: payload?.hashtag,
        },
      });
    },
    topWebPlatforms(payload) {
      return call(["admin", "dashboard", "parent", "top-webplatforms"], {
        method: "POST",
        body: {
          startDate: payload.from,
          endDate: payload.to,
          classrooms: payload.classrooms,
          student: payload?.students || "",
          lessons: payload.lessons,
          limit: payload?.limit,
          days: payload?.days,
        },
      });
    },

    collaborations(payload) {
      return call(["admin", "dashboard", "parent", "collaborations"], {
        method: "POST",
        body: {
          startDate: payload.from,
          endDate: payload.to,
          classrooms: payload.classrooms ? payload.classrooms : [],
          student: payload?.students || "",
          lessons: payload.lessons,
          days: payload?.days,
        },
      });
    },

    McqProgress(payload) {
      return call(["admin", "dashboard", "parent", "mcq-progress"], {
        method: "POST",
        body: {
          startDate: payload.from,
          endDate: payload.to,
          classrooms: payload.classrooms ? payload.classrooms : [],
          student: payload?.students || "",
          lessons: payload.lessons,
          weeks: payload?.weeks?.length ? payload?.weeks : null,
        },
      });
    },
  },
  notification: {
    list(params) {
      return call(["admin","feed"], {
        method: "GET",
        auth: true,
        params: formatObject(params),
      });
    },
    notificationExport(payload) {
      return call(["admin", "notification", "export"], {
        method: "GET",
        auth: true,
        params: payload,
      });
    },
    listStatus(params) {
      return call(["admin", "push-notification"], {
        method: "GET",
        auth: true,
        params,
      });
    },
    classroomNotification(id, params) {
      return call(["admin", "feed"], {
        method: "GET",
        auth: true,
        params: formatObject({...params, classroom: id}),
      });
    },
    classroomNotificationDelete(userId) {
      return call(["admin", "feed", userId], {
        method: "DELETE",
        auth: true,
      });
    },
    send(payload) {
      return call(["admin", "feed"], {
        method: "POST",
        auth: true,
        body: payload,
      });
    },
  },
  admin: {
    list(params) {
      return call(["admin", "admin-user"], {
        method: "GET",
        auth: true,
        params: formatObject(params),
      });
    },
    allList(params) {
      return call(["admin", "admin-user", "all"], {
        method: "GET",
        auth: true,
        params: formatObject(params),
      });
    },
    update(payload, userId) {
      return call(["admin", "admin-user", userId], {
        method: "PATCH",
        body: payload,
        auth: true,
      });
    },
    details(id) {
      return call(["admin", "admin-user", id], {
        method: "GET",
        auth: true,
      });
    },
    add(payload) {
      return makeRequest("POST", `${API_URL}/admin/admin-user`, payload);
    },
    delete(userId) {
      return call(["admin", "admin-user", userId], {
        method: "DELETE",
        auth: true,
      });
    },
    exportData(bodyObj) {
      return call(["admin", "admin-user", "export"], {
        method: "POST",
        auth: true,
        body: bodyObj,
      });
    },
  },
  users: {
    list(payload = {}) {
      return call(["admin", "students"], {
        method: "GET",
        auth: true,
        params: payload,
      });
    },
    getAllStudents(payload = {}) {
      return call(["admin", "students", "all"], {
        method: "GET",
        auth: true,
        params: payload,
      });
    },
    classroomList(payload) {
      return call(["admin", "students", "all"], {
        method: "GET",
        auth: true,
        params: payload,
      });
    },
    add(payload) {
      return makeRequest(
        "POST",
        `${API_URL}/admin/students`,
        JSON.stringify(payload)
      );
    },
    bulk_update(payload) {
      return call(["admin", "students", "bulk-update"], {
        method: "PATCH",
        body: payload,
        auth: true,
      });
    },
    update(payload, userId) {
      return makeRequest(
        "PATCH",
        `${API_URL}/admin/students/${userId}`,
        JSON.stringify(payload)
      );
    },
    delete(userId) {
      return call(["admin", "students", userId], {
        method: "DELETE",
        auth: true,
      });
    },
    details(id) {
      return call(["admin", "students", id], {
        method: "GET",
        auth: true,
      });
    },
    generateCompanion(id, payload) {
      return call(["admin", "students", "generate-companion", id], {
        method: "POST",
        body: payload,
        auth: true,
      });
    },
    uploadAvatar(payload) {
      return makeRequest("POST", `${API_URL}/user/set/avatar`, payload);
    },
    // search(classroom_id) {
    //   return makeRequest("POST", `${API_URL}/user?classroom=${classroom_id}`);
    // },
    search(params) {
      return call(["admin", "students"], {
        method: "POST",
        auth: true,
        // params,
      });
    },
    notification(payload) {
      return call(["user", "notification"], {
        method: "POST",
        body: payload,
        auth: true,
      });
    },
    listNotification(params = {}) {
      return call(["admin","feed"], {
        method: "GET",
        auth: true,
        params,
      });
    },
    notificationDetails(id) {
      return call(["user", "notification", id], {
        method: "GET",
        auth: true,
        params: {
          notificationId: id,
        },
      });
    },
    forgotPassword(payload) {
      return call(["auth", "admin", "forgot-password"], {
        method: "POST",
        body: payload,
      });
    },
    resetPassword(payload) {
      return call(["auth", "admin", "resetPassword"], {
        method: "POST",
        body: payload,
      });
    },
    multiDelete(userId) {
      return call(["admin", "students", "bulk-remove"], {
        method: "DELETE",
        body: { students: userId },
        auth: true,
      });
    },
    exportStudents(payload = {}) {
      return call(["admin", "students", "export"], {
        method: "POST",
        body: payload,
        auth: true,
      });
    },
    // Generate token for accessing student files
    generateToken(studentId) {
      return call(["admin", "obot", "token", studentId], {
        method: "GET",
        auth: true
      });
    },
    // Fetch student's memory file
    fetchMemoryFile(token, user_id) {
      return request(`${config.anabotApiBase}/api/v2/memory?user_id=${user_id}`, {
        method: "GET",
        auth: true,
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {token }
      });
    },
    // Fetch student's data file
    fetchDataFile(token) {
      return request(`${config.anabotApiBase}/api/v2/data-file`, {
        method: "GET",
        auth: true,
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: { token }
      });
    },

    // Gallery/settings controls (Students listing opens modal but API is device-scoped)
    // Keeping these under users for backward compatibility with the modal's `scope="student"`.
    getGallerySettings(deviceId) {
      return call(["admin", "devices", deviceId, "settings"], {
        method: "GET",
        auth: true,
      });
    },
    updateGallerySettings(deviceId, payload = {}) {
      return call(["admin", "devices", deviceId, "settings"], {
        method: "PATCH",
        auth: true,
        body: payload,
      });
    },
    // Fetch chat history for a specific thread
    fetchChatHistory(token, threadId, userId) {
      const url = `${config.anabotApiBase}/api/v2/anabot/history/${threadId}/versions?&user_id=${userId}`;
      return request(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    },
    // Fetch chat threads
    fetchChatThreads(token, userId, page = 1, size = 10) {
      const url = `${config.anabotApiBase}/api/v2/anabot/threads?user_id=${userId}&page=${page}&size=${size}`;
      return request(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    },
    getAnabotAnalytics(payload) {
      let url = `${config.anabotApiBase}/api/v2/analytics?sort_order=${payload?.sort_order || 'desc'}&page=${payload?.page || 1}&size=${payload?.limit || 10}`;
      if (payload?.start_date) url += `&start_date=${payload.start_date}`;
      if (payload?.end_date) url += `&end_date=${payload.end_date}`;
      if (payload?.name) url += `&name=${encodeURIComponent(payload.name)}`;
      if (payload?.date_preset && payload.date_preset !== "null") url += `&date_preset=${payload.date_preset}`;
      return request(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${getObotToken()}`,
        },
      });
    },
    exportAnabotCSV(payload) {
      let url = `${config.anabotApiBase}/api/v2/analytics/export-csv?sort_order=${payload?.sort_order || 'desc'}`;
      
      if (payload?.start_date) url += `&start_date=${payload.start_date}`;
      if (payload?.end_date) url += `&end_date=${payload.end_date}`;
      if (payload?.name) url += `&name=${encodeURIComponent(payload.name)}`;
      if (payload?.date_preset && payload.date_preset !== "null") url += `&date_preset=${payload.date_preset}`;
      
      return fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${getObotToken()}`,
          Accept: "application/json, text/csv, text/plain",
        },
      }).then(res => {
         if (!res.ok) throw new Error("Export failed");
         return res.blob();
      });
    },
    getAnabotDailyQueries(payload) {
      let url = `${config.anabotApiBase}/api/v2/daily-analytics?sort_order=${payload?.sort_order || 'desc'}&page=${payload?.page || 1}&size=${payload?.limit || 10}`;
      
      if (payload?.start_date) url += `&start_date=${payload.start_date}`;
      if (payload?.end_date) url += `&end_date=${payload.end_date}`;
      if (payload?.date_preset && payload.date_preset !== "null") {
        url += `&date_preset=${payload.date_preset}`;
      } else if (!payload?.start_date && !payload?.end_date) {
        url += `&date_preset=7d`;
      }
      return request(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${getObotToken()}`,
        },
      });
    },
  },
  schools: {
    list(payload = {}) {
      return call(["admin", "schools"], {
        method: "GET",
        auth: true,
        params: payload,
      });
    },
    listAll(payload = {}) {
      return call(["admin", "schools", "all"], {
        method: "GET",
        auth: true,
      });
    },
    add(payload) {
      return call(["admin", "schools"], {
        method: "POST",
        body: payload,
        auth: true,
      });
    },
    update(payload, schoolId) {
      return call(["admin", "schools", schoolId], {
        method: "PATCH",
        body: payload,
        // auth: true,
      });
    },
    delete(schoolId) {
      return call(["admin", "schools", schoolId], {
        method: "DELETE",
        auth: true,
      });
    },
    details(schoolId) {
      return call(["admin", "schools", schoolId], {
        method: "GET",
        auth: true,
      });
    },
    listAll() {
      return call(["admin", "schools", "all"], {
        method: "GET",
        auth: true,
      });
    },
    export(bodyParam = undefined) {
      return call(["admin", "schools", "export"], {
        method: "POST",
        auth: true,
        body: bodyParam,
      });
    },
  },
  organizations: {
    listAll(payload = {}) {
      return call(["admin", "organizations", "all"], {
        method: "GET",
        auth: true,
      });
    },
    getTerms(payload = {}) {
      return call(["admin", "organizations", "get-terms",payload], {
        method: "GET",
        auth: true,
      });
    },
    list(payload = {}) {
      return call(["admin", "organizations"], {
        method: "GET",
        auth: true,
        params: payload,
      });
    },
    add(payload) {
      return makeRequest("POST", `${API_URL}/admin/organizations`, payload);
    },
    update(payload, organizationId) {
      return makeRequest(
        "PATCH",
        `${API_URL}/admin/organizations/${organizationId}`,
        JSON.stringify(payload)
      );
    },
    updateWow(payload, organizationId) {
      return makeRequest(
        "PATCH",
        `${API_URL}/admin/websites/wow/${organizationId}`,
        JSON.stringify(payload)
      );
    },
    delete(organizationId) {
      return call(["admin", "organizations", organizationId], {
        method: "DELETE",
        auth: true,
      });
    },
    exportDatas(payload = {}) {
      return call(["admin", "organizations", "export"], {
        method: "POST",
        body: payload,
        auth: true,
      });
    },
  },
  courses: {
    getFile(payload) {
      return call(["admin", "resource", "get-file"], {
        method: "POST",
        auth: true,
        body: payload,
      });
    },
    deleteTopic(courseId, unitId){
      return call(["admin", "courses", courseId, "unit", unitId,], {
        method: "DELETE",
        auth: true,
      });
    },
    exportCourse(payload) {
      return call(["admin", "courses", "export"], {
        method: "POST",
        auth: true,
        body: payload,
      });
    },
    publishedList(params = {}) {
      return call(["admin", "courses", "all"], {
        method: "GET",
        auth: true,
        params,
      });
    },
    list(params = {}) {
      return call(["admin", "courses"], {
        method: "GET",
        auth: true,
        params,
      });
    },
    listAll(params = {}) {
      return call(["admin", "courses", "all"], {
        method: "GET",
        auth: true,
        params,
      });
    },
    getLesson({ id, type }) {
      return call(["admin", "my-library", "resource-url"], {
        method: "GET",
        params: { type, id },
        auth: true,
      });
    },
    add(payload) {
      return makeRequest(
        "POST",
        `${API_URL}/admin/courses`,
        JSON.stringify(payload)
      );
    },
    genMcq(payload) {
      return makeRequest(
        "POST",
        `${API_URL}/admin/courses/unit/mcq/auto`,
        JSON.stringify(payload)
      );
    },
    genMcqOne(payload) {
      return makeRequest(
        "POST",
        `${API_URL}/admin/courses/unit/mcq/generate-missing-mcq`,
        JSON.stringify(payload)
      );
    },
    genMcqFromPrompt(payload) {
      return makeRequest(
        "POST",
        `${API_URL}/admin/courses/unit/mcq/from-prompt`,
        JSON.stringify(payload)
      );
    },
    edit(payload, courseId) {
      return makeRequest(
        "PATCH",
        `${API_URL}/admin/courses/${courseId}`,
        JSON.stringify(payload)
      );
    },
    details(courseId) {
      return call(["admin", "courses", "details", courseId], {
        method: "GET",
        auth: true,
      });
    },
    units(payload) {
      return call(["admin", "courses", "unit", "lessons"], {
        method: "GET",
        auth: true,
        params: formatObject(payload),
      });
    },
    unitsv1(payload) {
      return call(["admin", "courses", "unit", "details", payload?.courseUnit], {
        method: "GET",
        auth: true,
        params: formatObject(payload),
      });
    },
    allocateCourse(courseId, payload) {
      return call(["admin", "courses", "allocate-resource", courseId], {
        method: "PATCH",
        body: payload,
        auth: true,
      });
    },
    addExisting(courseId, payload) {
      return call(["admin", "courses", "allocate-resource", courseId], {
        method: "PATCH",
        body: payload,
        auth: true,
      });
    },
    deleteSingleLesson(payload, courseId, lessonId) {
      return call(["admin", "courses", "unit", "lesson", "remove", courseId], {
        method: "DELETE",
        body: payload,
        auth: true,
      });
    },
    deleteSingle(payload, courseId, resourceId) {
      return call(["admin", "courses", "remove-resource", courseId], {
        method: "DELETE",
        body: payload,
        auth: true,
      });
    },
    delete(courseId) {
      return call(["admin", "courses", courseId], {
        method: "DELETE",
        auth: true,
      });
    },
    duplicate(courseId) {
      return call(["admin", "courses", "duplicate", courseId], {
        method: "PATCH",
        body: courseId,
        auth: true,
      });
    },
    dragLessons(payload, courseId) {
      return call(["admin", "courses", "unit","order", courseId], {
        method: "PATCH",
        auth: true,
        body: payload,
      });
    },
    getUnit(courseId) {
      return call(["admin", "courses", "unit", courseId], {
        method: "GET",
        auth: true,
        // body: payload,
      });
    },
    getUnitv1(courseId) {
      return call(["admin", "courses", "unit", "v1", courseId], {
        method: "GET",
        auth: true,
        // body: payload,
      });
    },
    publishData(courseId) {
      return call(["admin", "courses", "publish", courseId], {
        method: "PATCH",
        body: courseId,
        auth: true,
      });
    },
    generateLessonFromLibrary(courseId, payload) {
      return call(["admin", "courses", "unit", "lesson", "generate", courseId], {
        method: "POST",
        body: payload,
        auth: true,
      });
    },
  },
  test: {
    list(payload) {
      return call(["admin", "mcq"], {
        method: "GET",
        params: payload || {},
        auth: true,
      });
    },
    listClass(payload) {
      return call(["admin", "my-classroom" , "mcq", payload.classId], {
        method: "GET",
        params: payload || {},
        auth: true,
      });
    },
    mcqAllocate(payload) {
      return call(
        [
          "admin",
          "courses",
          "unit",
          payload?.id,
          payload?.mcq,
          payload?.courseUnit,
        ],
        {
          method: "PATCH",
          body: payload,
          auth: true,
        }
      );
    },
    myClassroomMcqAllocate(payload){
      return call(
        [
          "admin",
          "my-classroom",
          "course",
          "unit",
          "mcq",
          payload?.id,
          payload?.mcq,
          payload?.courseUnit,
        ],
        {
          method: "PATCH",
          body: payload,
          auth: true,
        }
      );
    },
    listMcqProgress(payload) {
      return call(["admin", "mcq", "list-mcq-progress"], {
        method: "GET",
        params: payload || {},
        auth: true,
      });
    },
    listMcqProgressExport(payload) {
      return makeRequest(
        "POST",
        `${API_URL}/admin/mcq/export-mcq-progress`,
        JSON.stringify(payload)
      );
    },
    report(payload) {
      return call(["admin", "mcq", "lesson-mcq-report"], {
        method: "GET",
        params: payload || {},
        auth: true,
      });
    },
    downloadReport(payload) {
      return call(["admin", "mcq", "generate-lesson-mcq-report"], {
        method: "GET",
        params: payload || {},
        auth: true,
      });
    },
    add(payload) {
      return makeRequest(
        "POST",
        `${API_URL}/admin/mcq`,
        JSON.stringify(payload)
      );
    },
    uploadAssertion(payload) {
      return makeRequest(
        "POST",
        `${API_URL}/admin/mcq/users-test-assign/`,
        payload
      );
    },
    publishMcq(id) {
      return makeRequest(
        "PATCH",
        `${API_URL}/admin/mcq/publish/${id}`,
        JSON.stringify({})
      );
    },
    update(payload, id) {
      return makeRequest(
        "PATCH",
        `${API_URL}/admin/mcq/${id}`,
        JSON.stringify(payload)
      );
      // return call(["admin", "mcq",id], {
      //   method: "PATCH",
      //   body: JSON.stringify(payload),
      //   auth: true,
      // });
    },
    delete(testid) {
      return call(["admin", "mcq", testid], {
        method: "DELETE",
        // body: testid,
        auth: true,
      });
    },
    getReport(testid) {
      return call(["admin", "mcq", "usersBytest"], {
        method: "GET",
        params: { testid },
        auth: true,
      });
    },
    byFilter(subject, grade) {
      return call(["admin", "mcq", "getTestsForLesson"], {
        method: "GET",
        auth: true,
        // params: {
        //   subject,
        //   grade,
        // },
      });
    },
    publish(body) {
      return call(["admin", "mcq", "publish"], {
        method: "PATCH",
        body,
        auth: true,
      });
    },
  },
  role: {
    list(payload = {}) {
      return call(["admin", "roles"], {
        method: "GET",
        auth: true,
        params: payload,
      });
    },
    listAll(payload = {}) {
      return call(["admin", "roles", "all"], {
        method: "GET",
        auth: true,
        params: payload,
      });
    },
    listMenu() {
      return call(["admin", "menus"], {
        method: "GET",
        auth: true,
      });
    },
    addRole(payload) {
      return call(["admin", "roles"], {
        method: "POST",
        body: payload,
        auth: true,
      });
    },
    delete(id) {
      return call(["admin", "roles", id], {
        method: "DELETE",
        auth: true,
      });
    },
    update(payload, id) {
      return call(["admin", "roles", id], {
        method: "PATCH",
        body: payload,
        auth: true,
      });
    },
  },
  survey: {
    list() {
      return call(["admin", "mcq", "list-survay"], {
        method: "GET",
        auth: true,
      });
    },
    add(payload) {
      return makeRequest("POST", `${API_URL}/admin/mcq/survay/`, payload);
    },
    uploadAssertion(payload) {
      return makeRequest(
        "POST",
        `${API_URL}/admin/mcq/users-survey-assign/`,
        payload
      );
    },
    update(payload) {
      return call(["admin", "mcq", "update-survay"], {
        method: "POST",
        body: payload,
        auth: true,
      });
    },
    delete(surveyid) {
      return call(["admin", "mcq", "survay"], {
        method: "DELETE",
        body: surveyid,
        auth: true,
      });
    },
    getReport(surveyid) {
      return call(["admin", "mcq", "usersBysurvey"], {
        method: "GET",
        params: { surveyid },
        auth: true,
      });
    },
  },
  developer:{
    list(params) {
      return call(["dashboard", "location"], {
        method: "GET",
        auth: true,
        params,
      });
    },
  },
  rewards: {
    list(params) {
      return call(["admin", "reward"], {
        method: "GET",
        auth: true,
        params,
      });
    },
    create(payload) {
      return makeRequest("POST", `${API_URL}/admin/reward`, payload);
    },
  },
  groups: {
    list(payload) {
      return call(["admin", "chat", "group"], {
        method: "GET",
        auth: true,
        ...(payload
          ? {
              params: payload,
            }
          : {}),
      });
    },
    history(payload) {
      return call(["admin", "chat", "history"], {
        method: "POST",
        body: payload,
        auth: true,
      });
    },
    add(payload) {
      return call(["admin", "chat", "group"], {
        method: "POST",
        body: payload,
        auth: true,
      });
    },
    update(payload) {
      return call(["admin", "chat", "group"], {
        method: "PUT",
        body: payload,
        auth: true,
      });
    },
    delete(groupid) {
      return call(["admin", "chat", "group"], {
        method: "DELETE",
        body: groupid,
        auth: true,
      });
    },
    sendChatReply(payload) {
      return call(["admin", "chat", "sendMessage"], {
        method: "POST",
        body: payload,
        auth: true,
      });
    },
    sendMessage(id, payload) {
      return call(["admin", "chat", "group", "sendMessage", id], {
        method: "POST",
        auth: true,
        body: payload,
      });
    },
    chatExport() {
      return call(["admin", "chat", "exportChat"], {
        method: "GET",
        auth: true,
      });
    },
  },
  subjects: {
    list() {
      return call(["admin", "subject"], {
        method: "GET",
        auth: true,
      });
    },
    add(payload) {
      return makeRequest("POST", `${API_URL}/admin/subject/`, payload);
    },
    update(payload, subjectId) {
      return makeRequest(
        "PATCH",
        `${API_URL}/admin/subject/${subjectId}`,
        payload
      );
    },
    delete(subjectId) {
      return call(["admin", "subject", subjectId], {
        method: "DELETE",
        auth: true,
      });
    },
  },
  grades: {
    list() {
      return call(["admin", "grade"], {
        method: "GET",
        auth: true,
      });
    },
    add(payload) {
      return call(["admin", "grade"], {
        method: "POST",
        body: payload,
        auth: true,
      });
    },
    update(payload, gradeId) {
      return call(["admin", "grade", gradeId], {
        method: "PATCH",
        body: payload,
        auth: true,
      });
    },
  },
  books: {
    exportBonus() {
      return call(["admin", "website", "bonus", "export"], {
        method: "GET",
        auth: true,
      });
    },
    myLibraryExport(payload) {
      return call(["admin", "library", "export"], {
        method: "POST",
        auth: true,
        body: payload,
      });
    },
    list(params) {
      return call(["admin", "library"], {
        method: "GET",
        auth: true,
        params,
      });
    },
    search(payload) {
      return call(["admin", "library", "search"], {
        method: "POST",
        body: payload,
        auth: true,
      });
    },
    add(payload) {
      return makeRequest(
        "POST",
        `${API_URL}/admin/library`,
        JSON.stringify(payload)
      );
    },
    update(payload, resourceId) {
      return makeRequest(
        "PATCH",
        `${API_URL}/admin/library/${resourceId}`,
        JSON.stringify(payload)
      );
    },
    delete(resourceId) {
      return call(["admin", "library", resourceId], {
        method: "DELETE",
        auth: true,
      });
    },
    details(resourceId) {
      return call(["admin", "library", resourceId], {
        method: "GET",
        auth: true,
      });
    },
    version: {
      add(payload, bookId) {
        return makeRequest(
          "POST",
          `${API_URL}/admin/library/version/${bookId}`,
          payload
        );
      },
      delete(versionId) {
        return call(["admin", "library", "version", versionId], {
          method: "DELETE",
          auth: true,
        });
      },
    },
  },
  bonusContent: {
    list(params) {
      return call(["admin", "my-library"], {
        method: "GET",
        auth: true,
        params,
      });
    },
    listStudents(id) {
      return call(["admin", "my-library","students", id], {
        method: "GET",
        auth: true,
        // params,
      });
    },
    listWebStudents(id) {
      return call(["admin", "my-websites","students", id], {
        method: "GET",
        auth: true,
        // params,
      });
    },
    listStudentStatus(params) {
      return call(["admin", "my-library", "students", params.resource], {
        method: "GET",
        auth: true,
        // params,
      });
    },
    listStatus(params) {
      return call(["admin", "push-notification"], {
        method: "GET",
        auth: true,
        params,
      });
    },
    search(payload) {
      return call(["admin", "library", "bonus", "search"], {
        method: "POST",
        body: payload,
        auth: true,
      });
    },
    add(payload) {
      return makeRequest(
        "POST",
        `${API_URL}/admin/my-library`,
        JSON.stringify(payload)
      );
    },
    update(payload, resourceId) {
      return makeRequest(
        "PATCH",
        `${API_URL}/admin/my-library/${resourceId}`,
        JSON.stringify(payload)
      );
    },
    delete(resourceId) {
      return call(["admin", "my-library", resourceId], {
        method: "DELETE",
        auth: true,
      });
    },
    myLibraryExport(payload) {
      return call(["admin", "my-library", "export"], {
        method: "POST",
        auth: true,
        body: payload,
      });
    },
    details(resourceId) {
      return call(["admin", "my-library", resourceId], {
        method: "GET",
        auth: true,
      });
    },
    version: {
      add(payload, bookId) {
        return makeRequest(
          "POST",
          `${API_URL}/admin/resource/bonus/version/${bookId}`,
          payload
        );
      },
      delete(versionId) {
        return call(["admin", "resource", "bonus", "version", versionId], {
          method: "DELETE",
          auth: true,
        });
      },
    },
    createMyLibrary(payload) {
      return call(["admin", "my-library"], {
        method: "POST",
        body: payload,
        auth: true,
      });
    },
    getImages(resourceId) {
      return call(["admin", "tech-support", resourceId], {
        method: "GET",
        auth: true,
      });
    },
  },
  apps: {
    list(params) {
      return call(["admin", "app-version"], {
        method: "GET",
        auth: true,
        params,
      });
    },
    get(params) {
      return call(["admin", "app-version", params], {
        method: "GET",
        auth: true,
      });
    },
    save(payload) {
      return makeRequest(
        "POST",
        `${API_URL}/admin/app-version`,
        JSON.stringify(payload)
      );
    },
    update(payload, appId) {
      return makeRequest(
        "PATCH",
        `${API_URL}/admin/app-version/${appId}`,
        JSON.stringify(payload)
      );
    },
       updateNotify(payload, appId) {
      return makeRequest(
        "PATCH",
        `${API_URL}/admin/app-version/notify/${appId}`,
        
        JSON.stringify({})
      );
    },
    delete(appId) {
      return call(["admin", "app-version", appId], {
        method: "DELETE",
        auth: true,
      });
    },
  },
  otherApps: {
    list() {
      return call(["admin", "custom", "other-apps"], {
        method: "GET",
        auth: true,
      });
    },
    save(payload) {
      return makeRequest("POST", `${API_URL}/admin/custom/other-apps`, payload);
    },
    update(payload, appId) {
      return makeRequest(
        "PATCH",
        `${API_URL}/admin/custom/other-apps/${appId}`,
        payload
      );
    },
    delete(appId) {
      return call(["admin", "custom", "other-apps", appId], {
        method: "DELETE",
        auth: true,
      });
    },
  },
  websites: {
    getThresold() {
      return call(["admin-settings"], {
        method: "GET",
        auth: true,
      });
    },
    getDetailsHistory(id) {
      return call(["admin", "websites","history", id], {
        method: "GET",
        auth: true,
        params: {},
      });
    },
    list(params) {
      return call(["admin", "websites"], {
        method: "GET",
        auth: true,
        params,
      });
    },
    listRestricted(params) {
      return call(["admin", "tech-support", "restricted-url"], {
        method: "GET",
        auth: true,
        params,
      });
    },
    updateRestricted(id, body) {
      return call(["admin", "tech-support", "restricted-url", id], {
        method: "PATCH",
        auth: true,
        body,
      });
    },
    add(payload) {
      return makeRequest("POST", `${API_URL}/admin/websites`, payload);
    },
    update(payload, websiteId) {
      return makeRequest(
        "PATCH",
        `${API_URL}/admin/websites/${websiteId}`,
        payload
      );
    },
    delete(websiteId) {
      return call(["admin", "websites", websiteId], {
        method: "DELETE",
        auth: true,
      });
    },
    editWebPlatform(body, id) {
      return call(["admin", "websites", id], {
        method: "PATCH",
        auth: true,
        body,
      });
    },
    exportWebPlatform(body) {
      return call(["admin", "websites", "export"], {
        method: "POST",
        auth: true,
        body,
      });
    },
  },
  bonusWebsite: {
    list(params) {
      return call(["admin", "my-websites"], {
        method: "GET",
        auth: true,
        params,
      });
    },
    listStatusWeb(params) {
      // /api/admin/feed/students/{id}
      return call(["admin", "my-websites", "students", params?.resource], {
        method: "GET",
        auth: true,
        // params,
      });
    },
    listStatus(params) {
      // /api/admin/feed/students/{id}
      return call(["admin", "feed", "students", params?.resource], {
        method: "GET",
        auth: true,
        // params,
      });
    },
    listSingle(id) {
      return call(["admin", "my-websites", id], {
        method: "GET",
        auth: true,
      });
    },
    add(payload) {
      return makeRequest(
        "POST",
        `${API_URL}/admin/my-websites`,
        JSON.stringify(payload)
      );
    },
    getMetaData(payload) {
      return makeRequest(
        "POST",
        `${API_URL}/admin/websites/meta-details`,
        JSON.stringify(payload)
      );
    },
    update(payload, websiteId) {
      return makeRequest(
        "PATCH",
        `${API_URL}/admin/my-websites/${websiteId}`,
        JSON.stringify(payload)
      );
    },
    delete(websiteId) {
      return call(["admin", "my-websites", websiteId], {
        method: "DELETE",
        auth: true,
      });
    },
    createMyLibrary(payload) {
      return call(["admin", "my-websites"], {
        method: "POST",
        auth: true,
        body: payload,
      });
    },
    exportMyWebsite(payload) {
      return call(["admin", "my-websites", "export"], {
        method: "POST",
        auth: true,
        body: payload,
      });
    },
  },
  classroomAdmin: {
    list(params) {
      return call(["admin", "classrooms"], {
        method: "GET",
        auth: true,
        params,
      });
    },
    listSingle(id, params) {
      return call(["admin", "classrooms","v2", id], {
        method: "GET",
        auth: true,
        params
      });
    },
    listAll(params) {
      return call(["admin", "classrooms", "all"], {
        method: "GET",
        auth: true,
        params,
      });
    },
    listAllV(params) {
      return call(["admin", "classrooms", "all", "v1"], {
        method: "GET",
        auth: true,
        params,
      });
    },
    removeStudent(payload = {}) {
      // POST /api/admin/classrooms/students/remove
      // body: { classroomId: number|string, studentId: number|string }
      return call(["admin", "classrooms", "students", "remove"], {
        method: "POST",
        auth: true,
        body: payload,
      });
    },
    classroomAdminTeachers(school_id) {
      return call(["admin", "admin-user"], {
        method: "GET",
        auth: true,
        params: formatObject(
          school_id
            ? {
                school: school_id,
                limit: 1000,
              }
            : { limit: 1000 }
        ),
      });
    },
    classroomAdminUsers(school_id,organization_id, assigned = "") {
      let data = {}
      if(organization_id) data.organizations = organization_id ? organization_id : ''
      if(school_id) data.schools = school_id
      if(assigned !== "") data.assigned = assigned
      return call(["admin", "students", "all"], {
        method: "GET",
        auth: true,
        params: data,
      });
    },
    listTeachers() {
      return call(["admin", "user"], {
        method: "GET",
        auth: true,
      });
    },
    add(payload) {
      return makeRequest(
        "POST",
        `${API_URL}/admin/classrooms`,
        JSON.stringify(payload)
      );
    },
    update(payload, classroom_id) {
      return makeRequest(
        "PATCH",
        `${API_URL}/admin/classrooms/${classroom_id}`,
        JSON.stringify(payload)
      );
    },
    delete(classroom_id) {
      return call(["admin", "classrooms", classroom_id], {
        method: "DELETE",
        auth: true,
      });
    },
    exportClassRoom(payload) {
      return call(["admin", "classrooms", "export"], {
        method: "POST",
        auth: true,
        body: payload,
      });
    },
  },
  lessonBuilder: {
    get(payload) {
      return call(["admin", "lessonbuilder"], {
        method: "GET",
        auth: true,
        params: formatObject(payload),
      });
    },
    ChangeLessonTopic(id, payload) {
      return call(["admin", "courses", "unit","lesson","move", id], {
        method: "PATCH",
        auth: true,
        body: formatObject(payload),
      });
    },
    PDF(id) {
      return call(["admin", "lesson", "get-lesson-pdf", id], {
        method: "GET",
        auth: true,
      });
    },
    getLesson(payload) {
      return call(["admin", "lesson"], {
        method: "GET",
        auth: true,
        params: formatObject(payload),
      });
    },
    allocate(id, payload) {
      return call(["admin", "courses", "unit", "lesson", "allocate", id], {
        method: "POST",
        auth: true,
        body: formatObject(payload),
      });
    },
    add(payload) {
      return call(["admin", "lesson"], {
        method: "POST",
        auth: true,
        body: formatObject(payload),
      });
    },
    getDetails(id) {
      return call(["admin", "lessonbuilder", id], {
        method: "GET",
        auth: true,
      });
    },
    save(payload) {
      return call(["admin", "lessonbuilder"], {
        method: "POST",
        auth: true,
        body: formatObject(payload),
      });
    },
    update(id, payload) {
      return call(["admin", "lessonbuilder", id], {
        method: "PATCH",
        auth: true,
        body: formatObject(payload),
      });
    },
    LessonAppPublish(id, payload) {
      return call(
        ["admin", "my-classroom", "course", "unit", "lesson", "publish", id],
        {
          method: "PATCH",
          auth: true,
          body: formatObject(payload),
        }
      );
    },
    LessonPublishClassroom(id, payload) {
      return call(
        ["admin", "courses", "unit", "lesson", "publish", "classroom", id],
        {
          method: "PATCH",
          auth: true,
          body: formatObject(payload),
        }
      );
    },
    LessonStatus(id, payload) {
      return call(["admin", "lesson", "update", "status", id], {
        method: "PATCH",
        auth: true,
        body: formatObject(payload),
      });
    },
    updateLesson(id, payload) {
      return call(["admin", "lesson", id], {
        method: "PATCH",
        auth: true,
        body: formatObject(payload),
      });
    },
    unpublish(id) {
      return call(["admin", "lessonbuilder", "unpublish", id], {
        method: "PATCH",
        auth: true,
      });
    },
    deleteCourse(id, payload) {
      return call(["admin", "courses", "unit", "lesson", "deallocate", id], {
        method: "DELETE",
        auth: true,
        body: payload,
      });
    },
    delete(id) {
      return call(["admin", "lessonbuilder", id], {
        method: "DELETE",
        auth: true,
      });
    },
    deleteLesson(id,payload = {}) {
      return call(["admin", "lesson", id], {
        method: "DELETE",
        params: payload,
        auth: true,
      });
    },
    getLibrary(payload) {
      return call(["admin", "resource", "search"], {
        method: "POST",
        auth: true,
        params: payload,
      });
    },
    getMyLibrary(payload) {
      return call(["admin", "resource", "bonus"], {
        method: "GET",
        auth: true,
        params: payload,
      });
    },
    fileUpload(payload) {
      return makeRequest("POST", `${API_URL}/admin/file-upload`, payload);
    },
  },
  myClassroom: {
    resources(id, payload = {}) {
      return call(["admin", "my-classroom", "resources", id], {
        method: "GET",
        auth: true,
        params: payload,
      });
    },
    getAllUnpublished(id, payload = {}) {
      // /api/admin/my-classroom/course/unit/lesson/publish/summary/{id}
      return call(["admin", "my-classroom", "course", "unit","lesson","publish",  "summary", id], {
        method: "GET",
        auth: true,
        params: payload,
      });
    },
    classProgress(payload ) {
      return call(["admin", "my-classroom", "summary"], {
        method: "POST",
        auth: true,
        body: payload,
      });
    },
    classProgressExport(payload) {
      return call(["admin", "my-classroom", "summary", "export"], {
        method: "POST",
        auth: true,
        body: payload,
      });
    },
    classProgressExportAttempts(payload) {
      return call(["admin", "my-classroom", "summary", "export", "attempts"], {
        method: "POST",
        auth: true,
        body: payload,
      });
    },
    studentStatus(payload , classroom) {
      return call(["admin", "my-classroom",classroom, "lock-device"], {
        method: "POST",
        auth: true,
        body: payload,
      });
    },
    student(id) {
      return call(["admin", "my-classroom", "students", id], {
        method: "GET",
        auth: true,
      });
    },
    students(params) {
      return call(["admin", "my-classroom", "students", params.id], {
        method: "GET",
        auth: true,
        params
      });
    },
    resourcesDelete(classroom_id, payload) {
      return call(["admin", "my-classroom", "resources", classroom_id], {
        method: "DELETE",
        body: payload,
        auth: true,
      });
    },
    getUnit(courseId) {
      return call(["admin", "my-classroom", "course", "unit", courseId], {
        method: "GET",
        auth: true,
        // body: payload,
      });
    },
    getUnitv1(classroomId, courseId) {
      return call(["admin", "my-classroom", "course", "unit", courseId, classroomId], {
        method: "GET",
        auth: true,
        // body: payload,
      });
    },
    launchAll(unit_id, payload) {
      return call(["admin", "my-classroom", "course", "unit", "lesson", "bulk-publish" , unit_id], {
        method: "PATCH",
        body: payload,
        auth: true,
      });
    },
    postEnable(classroom_id, payload) {
      return call(["admin", "my-classroom", classroom_id], {
        method: "PATCH",
        body: payload,
        auth: true,
      });
    },
    allocateResource(classroom_id, payload) {
      return call(["admin", "my-classroom", "resources", classroom_id], {
        method: "PATCH",
        body: payload,
        auth: true,
      });
    },
    units(payload) {
      return call(
        ["admin", "my-classroom", "course", "unit", "lesson", payload?.id],
        {
          method: "GET",
          auth: true,
          params: formatObject({ courseUnit: payload?.courseUnit }),
        }
      );
    },
    unitsv1(payload) {
      return call(
        ["admin", "my-classroom", "course", "unit", "v1", payload?.id],
        {
          method: "GET",
          auth: true,
          params: formatObject({ courseUnit: payload?.courseUnit }),
        }
      );
    },
    listSingleClassroom(classroom_id) {
      return makeRequest("GET", `${API_URL}/admin/classrooms/${classroom_id}`);
    },
    listSingleClassroomChat(classroom_id) {
      return makeRequest(
        "GET",
        `${API_URL}/admin/classroom/${classroom_id}?type=chat`
      );
    },
    list(payload) {
      return call(["admin", "classrooms"], {
        method: "GET",
        auth: true,
        ...(payload
          ? {
              params: payload,
            }
          : {}),
      });
    },
    myList(params) {
      return call(["admin", "my-classroom"], {
        method: "GET",
        auth: true,
        params
      });
    },
    myLockList(id) {
      return call(["admin", "my-classroom", "locked-status", id], {
        method: "GET",
        auth: true,
      });
    },
    edit(classroom_id, payload) {
      return call(["admin", "classroom", classroom_id], {
        method: "PATCH",
        body: payload,
        auth: true,
      });
    },
    details(classroom_id) {
      return call(["admin", "classroom", classroom_id], {
        method: "GET",
        auth: true,
      });
    },
      addExisting(classroom_id, payload) {
      return call(["admin", "classroom", classroom_id, "resource"], {
        method: "PATCH",
        body: payload,
        auth: true,
      });
    },
    addUser(payload) {
      return call(["user"], {
        method: "POST",
        auth: true,
        body: payload,
      });
    },
    sendMessage(classroom_id, payload) {
      return call(["admin", "classroom", "sendMessage", classroom_id], {
        method: "POST",
        auth: true,
        body: payload,
      });
    },
    publishLesson(classroom_id, lesson_id) {
      return call(
        [
          "admin",
          "classroom",
          "publishLesson",
          classroom_id,
          "resource",
          lesson_id,
        ],
        {
          method: "POST",
          auth: true,
        }
      );
    },
    deleteSingle(payload, classroom_id, resourceId) {
      return call(
        ["admin", "classroom", classroom_id, "resource", resourceId],
        {
          method: "DELETE",
          body: payload,
          auth: true,
        }
      );
    },
    launchRating(payload) {
      return call(
        ["admin", "my-classroom", "launch-rating", payload?.classroom],
        {
          method: "GET",
          auth: true,
          // body: formatObject(payload),
        }
      );
    },
    dragLessons(payload, classroom_id) {
      return call(["admin", "classroom", "save-lesson-order", classroom_id], {
        method: "PATCH",
        auth: true,
        body: payload,
      });
    },
  },
  device: {
    getLocation(id) {
      return call(["admin", "device-location", id], {
        method: "GET",
        auth: true,
      });
    },
    tableList(payload = {}) {
      return call(["admin", "devices", "export-devices"], {
        method: "GET",
        auth: true,
        params: payload,
      });
    },
    downloadSheet(params) {
      return call(["admin", "summery"], {
        method: "GET",
        auth: true,
        params,
      });
    },
    listLocations() {
      return call(["admin", "devices", "location-place"], {
        method: "GET",
        auth: true,
      });
    },
    list(params) {
      return call(["admin", "devices", "list"], {
        method: "GET",
        auth: true,
        params,
      });
    },
    space(payload) {
      return call(["admin", "devices","bulk", "storage-clean"], {
        method: "POST",
        body: payload,
        auth: true,
      });
    },
    deviceAnalytics(payload) {
      return call(["admin", "devices","bulk", "analytics-get"], {
        method: "POST",
        body: payload,
        auth: true,
      });
    },
    exportTransaction(payload) {
      return call(["admin", "device-location", "export"], {
        method: "POST",
        body: payload,
        auth: true,
      });
    },
    addLocation(payload) {
      return call(["admin", "devices", "location-place"], {
        method: "POST",
        body: payload,
        auth: true,
      });
    },
    updateLocation(payload, id) {
      return call(["admin", "devices", "location-place", id], {
        method: "PATCH",
        body: payload,
        auth: true,
      });
    },
    deleteLocation(id) {
      return call(["admin", "devices", "location-place", "delete", id], {
        method: "DELETE",
        auth: true,
      });
    },
    summary(payload) {
      return call(["admin", "summery", "get"], {
        method: "GET",
        auth: true,
        params: payload,
      });
    },
    add(payload) {
      return call(["admin", "devices"], {
        method: "POST",
        body: JSON.stringify(payload),
        auth: true,
      });
    },
    update(payload, deviceId) {
      return call(["admin", "devices", deviceId], {
        method: "PATCH",
        body: JSON.stringify(payload),
        auth: true,
      });
    },
    delete(deviceId) {
      return call(["admin", "devices", deviceId], {
        method: "DELETE",
        auth: true,
      });
    },
    export(payload){
      return call(["admin", "devices","export"], {
        method: "POST",
        body: JSON.stringify(payload),
        auth: true,
      });
    },
    assignUser(payload, deviceId) {
      return call(["admin", "devices", "assign", deviceId], {
        method: "PATCH",
        body: payload,
        auth: true,
      });
    },
    multiUnpin(deviceid) {
      return call(["admin", "devices", "bulk", "pin"], {
        method: "PUT",
        body: { deviceid },
        auth: true,
      });
    },
    summaryButton() {
      return call(["admin", "summery"], {
        method: "GET",
        auth: true,
      });
    },
    locationUpdate(body) {
      return call(["admin", "devices", "bulk-location-update"], {
        method: "PATCH",
        body,
        auth: true,
      });
    },
    bulkLocationUpdate(body) {
      return call(["admin", "device-location", "bulkdevicelocation"], {
        method: "POST",
        body,
        auth: true,
      });
    },

    deviceDetails(id) {
      return call(["admin", "device-location", id], {
        method: "GET",
        auth: true,
      });
    },
    location(body) {
      return call(["admin", "summery", "location"], {
        method: "POST",
        body,
        auth: true,
      });
    },
    sleepAwake(body) {
      return call(["admin", "summery", "sleepAwake"], {
        method: "POST",
        body,
        auth: true,
      });
    },
    multiUnpin(deviceid) {
      return call(["admin", "devices", "bulk", "pin"], {
        method: "PUT",
        body: { deviceid },
        auth: true,
      });
    },
    summaryButton() {
      return call(["admin", "summery"], {
        method: "GET",
        auth: true,
      });
    },
    getFilteredDevices(payload = {}) {
      return call(["admin", "devices", "list-minimal"], {
        method: "POST",
        auth: true,
        body: JSON.stringify(payload),
      });
    },
    deviceBulkUpdate(path, data) {
      return makeRequest("PUT", `${API_URL}/admin/devices/bulk/${path}`, data);
    },
    deviceLocations() {
      return call(["admin", "devices", "locations"], {
        method: "GET",
        auth: true,
      });
    },

    // Device gallery/settings controls (used by SUPER_ADMIN in Devices listing)
    getGallerySettings(deviceId) {
      return call(["admin", "devices", deviceId, "gallery", "settings"], {
        method: "GET",
        auth: true,
      });
    },
    updateGallerySettings(deviceId, payload = {}) {
      return call(["admin", "devices", deviceId, "gallery", "settings"], {
        method: "PATCH",
        auth: true,
        body: payload,
      });
    },
  },
  health: {
    create(payload) {
      return call(["admin", "tech-support"], {
        method: "POST",
        auth: true,
        body: payload,
      });
    },
    createSocket(payload) {
      return call(["admin","tech-support", "chat-room"], {
        method: "POST",
        auth: true,
        body: payload,
      });
    },
    updateSocket(payload) {
      return call(["websockets","room", "participants"], {
        method: "POST",
        auth: true,
        body: payload,
      });
    },
    list() {
      return call(["admin", "tech-support"], {
        method: "GET",
        auth: true,
      });
    },
    listresource(id) {
      return call(["admin", "tech-support", "resource", id], {
        method: "GET",
        auth: true,
      });
    },
    pdfdecript(id) {
      return call(["admin", "library", "decrypt-pdf", id], {
        method: "GET",
        auth: true,
      });
    },
    listSearch(payload) {
      return call(["admin", "tech-support"], {
        method: "GET",
        auth: true,
        params: formatObject(payload),
      });
    },
    Areas() {
      return call(["admin", "tech-support", "category"], {
        method: "GET",
        auth: true,
        params: { isType: false },
      });
    },
    Types() {
      return call(["admin", "tech-support", "category"], {
        method: "GET",
        auth: true,
        params: { isType: true , limit: 1000},
      });
    },
    getTypes() {
      return call(["admin", "tech-support", "category", "all"], {
        method: "GET",
        auth: true,
        params: { isType: true },
      });
    },
    getAreas() {
      return call(["admin", "tech-support", "category", "all"], {
        method: "GET",
        auth: true,
        params: { isType: false },
      });
    },
    notification(payload) {
      return call(["admin", "notification"], {
        method: "POST",
        auth: true,
        body: payload,
      });
    },
    updateCategory(payload) {
      return call(["admin", "health", payload.ticketId], {
        method: "PATCH",
        auth: true,
        body: {
          type: payload.type,
          area: payload.area,
        },
      });
    },
    toggle(payload) {
      return call(["admin", "health", payload.id], {
        method: "PATCH",
        auth: true,
        body: {
          isClosed: payload.isClosed,
          closedOrReopenedMsg: payload.closedOrReopenedMsg,
        },
      });
    },
    history(payload) {
      return call(["admin", "chat", "history"], {
        method: "POST",
        body: payload,
        auth: true,
      });
    },
    updateEscalation(id, payload) {
      return call(["admin", "health", "update-escalation", id], {
        method: "PATCH",
        body: payload,
        auth: true,
      });
    },
    getHealthDetails(id) {
      return call(["admin", "tech-support","history", id], {
        method: "GET",
        auth: true,
        params: { type: "escalation" },
      });
    },
    getHealthDetailsHistory(id) {
      return call(["admin", "tech-support","device-activities", id], {
        method: "GET",
        auth: true,
        params: {},
      });
    },
    getDeviceDetailsHistory(id) {
      return call(["admin","devices", id], {
        method: "GET",
        auth: true,
        params: {},
      });
    },
    exportTechnicalSupports(payload) {
      return call(["admin", "tech-support", "export"], {
        method: "POST",
        auth: true,
        body: payload,
      });
    },
    editTechnicalSupport(payload, id) {
      return call(["admin", "tech-support", id], {
        method: "PATCH",
        auth: true,
        body: payload,
      });
    },
    exportTechnicalCategory(payload) {
      return call(["admin", "tech-support", "exportCategory"], {
        method: "POST",
        auth: true,
        body: payload,
      });
    },
    createTechnicalCategory(payload) {
      return call(["admin", "tech-support", "category"], {
        method: "POST",
        auth: true,
        body: payload,
      });
    },
    editTechnicalCategory(payload, id) {
      return call(["admin", "tech-support", "category", id], {
        method: "PATCH",
        auth: true,
        body: payload,
      });
    },
    removeTechnicalCategory(id) {
      return call(["admin", "tech-support", "category", id], {
        method: "DELETE",
        auth: true,
      });
    },
    createTechChat(payload) {
      return call(["admin", "tech-support", "message"], {
        method: "POST",
        auth: true,
        body: payload,
      });
    },
    getTechChatAvailable(id) {
      return call(["websockets", `messages?roomId=${id}`], {
        method: "GET",
        auth: true,
      });
    },
    getTechChatAvailablePagination(param){
      return call(["websockets", `messages`], {
        method: "GET",
        auth: true,
        params:param
      });
    }
  },
  psm: {
    add(payload) {
      return call(["psm"], {
        method: "POST",
        auth: true,
        body: payload,
      });
    },
    getIndividualDtl(id) {
      return call(["psm","student", id], {
        method: "GET",
        auth: true,
      });
    },
    export(payload) {
      return call(["psm", "export", payload], {
        method: "GET",
        auth: true,
        // params: payload,
      });
    },
    deleteIndividual(id, payload) {
      return call(["psm", "student", "day", id], {
        method: "DELETE",
        body: payload,
        auth: true,
      });
    },
    delete(id) {
      return call(["psm", id], {
        method: "DELETE",
        auth: true,
      });
    },
    list(params) {
      return call(["admin", "psm", "filter-pms"], {
        method: "GET",
        params,
        auth: true,
      });
    },
    listStuent(params) {
      return call(["psm", "student"], {
        method: "GET",
        params,
        auth: true,
      });
    },
    // export(body) {
    //   return call(["admin", "psm", "export-history"], {
    //     method: "POST",
    //     body,
    //     auth: true,
    //   });
    // },
    listPsm(payload) {
      return call(["psm"], {
        method: "GET",
        auth: true,
        ...(payload
          ? {
              params: payload,
            }
          : {}),
      });
    },
    listPsmClass(payload) {
      return call(["psm", "classroom", payload?.class], {
        method: "GET",
        auth: true,
        ...(payload
          ? {
              params: payload,
            }
          : {}),
      });
    },
    save(payload) {
      return makeRequest("POST", `${API_URL}/admin/psm`, payload);
    },
  },
  investors: {
    tableList(payload = {}) {
      return call(["admin", "sponsors"], {
        method: "GET",
        auth: true,
        params: payload,
      });
    },
    allSponsorList(payload = {}) {
      return call(["admin", "sponsors", "all"], {
        method: "GET",
        auth: true,
        params: payload,
      });
    },
    sizeList(payload = {}) {
      return call(["admin", "sponsors", "size"], {
        method: "GET",
        auth: true,
        params: payload,
      });
    },
    sectorList(payload = {}) {
      return call(["admin", "sponsors", "sector"], {
        method: "GET",
        auth: true,
        params: payload,
      });
    },
    add(payload) {
      return call(["admin", "sponsors"], {
        method: "POST",
        body: payload,
      });
    },
    update(payload, investorId) {
      return call(["admin", "sponsors", investorId], {
        method: "PATCH",
        body: payload,
      });
    },
    allInvestors() {
      return call(["admin", "sponsors"], {
        method: "GET",
        auth: true,
      });
    },
    delete(investorId) {
      return call(["admin", "sponsors", investorId], {
        method: "DELETE",
        auth: true,
      });
    },
    locationStatus() {
      return call(["admin","device-location","status"],{
        method:"GET",
        auth: true
      })
    },
    proposals(params = {}) {
      return call(["admin", "sponsors", "proposelNumbers"], {
        method: "GET",
        auth: true,
        params,
      });
    },
    lookup(params = {}) {
      return call(["admin", "sponsors", "conssultant", "lookup"], {
        method: "GET",
        auth: true,
        params,
      });
    },
    allDeviceTransactions(payload = {}) {
      return call(["admin", "device-location"], {
        method: "GET",
        auth: true,
        params: payload,
      });
    },
  },
  zoom: {
    save(body) {
      return call(["admin", "zoom-meeting"], {
        method: "POST",
        body,
        auth: true,
      });
    },
  },
  bbm: {
    get(params) {
      return call(["admin", "bbb"], {
        method: "GET",
        auth: true,
        params,
      });
    },
    getDetails(id) {
      return call(["admin", "bbb", id], {
        method: "GET",
        auth: true,
      });
    },
    save(body) {
      return call(["admin", "bbb"], {
        method: "POST",
        body,
        auth: true,
      });
    },
    delete(id) {
      return call(["admin", "bbb", id], {
        method: "DELETE",
        auth: true,
      });
    },
    edit(payload, id) {
      return call(["admin", "bbb", id], {
        method: "PATCH",
        auth: true,
        body: payload,
      });
    },
    endCall(id) {
      return call(["admin", "bbb", "end", id], {
        method: "PATCH",
        auth: true,
      });
    },
    publish(id, body) {
      return call(["admin", "bbb", "record", "publish", id], {
        method: "PATCH",
        auth: true,
        body,
      });
    },
    deleteRecord(id) {
      return call(["admin", "bbb", "record", "delete", id], {
        method: "DELETE",
        auth: true,
      });
    },
    start(id) {
      return call(["admin", "bbb", "start", id], {
        method: "PATCH",
        auth: true,
      });
    },
    joinMeeting(id) {
      return call(["admin", "bbb", "join", id], {
        method: "GET",
        auth: true,
      });
    },
    getMeetingUrl({ id, name }) {
      return call(["bbb", "guest-join", `${id}?name=${name}`], {
        method: "GET",
        auth: true,
      });
    },
    syncRecordings(id) {
      return call(["admin", "bbb", "record", "download", id], {
        method: "GET",
        auth: true,
      });
    },
  },
  profile: {
    uploadAvatar(payload) {
      return makeRequest("POST", `${API_URL}/admin/user/set/avatar`, payload);
    },
    changePassword(body, userId) {
      return call(["admin", "user", "change-password", userId], {
        method: "POST",
        body,
        auth: true,
      });
    },
    updateUser(id, body) {
      return call(["admin", "admin-user", "profile", id], {
        method: "PATCH",
        auth: true,
        body,
      });
    },
  },
  upload: {
    add(payload) {
      return uploadRequest(["admin", "uploads"], {
        method: "POST",
        body: payload,
        auth: true,
      });
    },
    getUrlPdf(payload) {
      return call(["admin", "lesson","get-contents"], {
        method: "POST",
        body: payload,
        auth: true,
      });
    },
  },
  mcq: {
    listAll(payload = undefined) {
      return call(["admin", "mcq", "all"], {
        method: "GET",
        auth: true,
        params: payload,
      });
    },
  },
  rewards: {
    listAllCatalogue(payload = undefined) {
      return call(["admin", "inventory"], {
        method: "GET",
        auth: true,
        params: payload,
      });
    },
    listAllAnalytics(payload = undefined) {
      return call(["dashboard", "watch-data", "student", payload?.student], {
        method: "GET",
        auth: true,
        params: payload,
      });
    },
    listAllCatalogueStatus(id) {
      return call(["admin", "inventory", "history", id], {
        method: "GET",
        auth: true,
        params: {},
      });
    },
    saveCatalogue(body) {
      return call(["admin", "inventory"], {
        method: "POST",
        body,
        auth: true,
      });
    },
    deleteCatalogue(id) {
      return call(["admin", "inventory", id], {
        method: "DELETE",
        auth: true,
      });
    },
    updateCatalogue(id, body) {
      return call(["admin", "inventory", "update", id], {
        method: "PATCH",
        auth: true,
        body,
      });
    },
    listAllApply(payload = undefined) {
      return call(["admin","drop", "apply", "list"], {
        method: "GET",
        auth: true,
        params: payload,
      });
    },
    analytics(body) {
      return call(["admin","devices", "bulk", "analytics-get"], {
        method: "POST",
        body,
        auth: true,
      });
    },
    saveApply(body) {
      return call(["admin", "drop", "apply"], {
        method: "POST",
        body,
        auth: true,
      });
    },
    updateApply(id, body) {
      return call(["admin", "drop", "apply", id], {
        method: "PATCH",
        auth: true,
        body,
      });
    },
    updateAward(id, body) {
      return call(["admin", "drop", "award", id], {
        method: "PATCH",
        auth: true,
        body,
      });
    },
    listAllOrder(payload = undefined) {
      return call(["admin", "order"], {
        method: "GET",
        auth: true,
        params: payload,
      });
    },
    listAllTransaction(payload = undefined) {
      return call(["admin", "transaction"], {
        method: "GET",
        auth: true,
        params: payload,
      });
    },
    saveOrder(body) {
      return call(["admin", "order"], {
        method: "POST",
        body,
        auth: true,
      });
    },
    updateOrder(id, body) {
      return call(["admin", "order", "update", id], {
        method: "PATCH",
        auth: true,
        body,
      });
    },
    applyStatus(id, params={}) {
      return call(["admin", "drop", "history", `${id}` ], {
        method: "GET",
        auth: true,
        params: params,
      });
    },
    orderStatus(id, params={}) {
      return call(["admin", "order", "history", `${id}` ], {
        method: "GET",
        auth: true,
        params: params,
      });
    },
    dropExport(payload) {
      return call(["admin", "drop", "export"], {
        method: "POST",
        auth: true,
        body: payload,
      });
    },
    orderExport(payload) {
      return call(["admin", "order", "export"], {
        method: "POST",
        auth: true,
        body: payload,
      });
    },
    inventoryExport(payload) {
      return call(["admin", "inventory", "export"], {
        method: "POST",
        auth: true,
        body: payload,
      });
    },
    transactionExport(payload) {
      return call(["admin", "transaction", "export"], {
        method: "POST",
        auth: true,
        body: payload,
      });
    },
    filterSummery(payload = undefined) {
      return call(["admin", "drop", "filter"], {
        method: "GET",
        auth: true,
        params: payload,
      });
    },
    updateBulk(body) {
      return call(["admin", "drop", "award", "bulk-update"], {
        method: "PATCH",
        auth: true,
        body,
      });
    },
    filterRules(payload = undefined) {
      return call(["admin", "drop", "rules"], {
        method: "GET",
        auth: true,
        params: payload,
      });
    },
  },
  feedBack: {
    listAllFeedback(payload = undefined) {
      return call(["admin", "feedback"], {
        method: "GET",
        auth: true,
        params: payload,
      });
    },
    saveFeedBack(body) {
      return call(["admin", "feedback"], {
        method: "POST",
        body,
        auth: true,
      });
    },
  },
  analytics:{
    list({studentId , graphId}) {      
      return call(["dashboard", "analytics" ,"graph", studentId ,graphId], {
        method: "GET",
        auth: true,
      });
    },
    exportCSV(studentId){
     return call(["dashboard", "analytics" ,"export","student", studentId], {
        method: "GET",
        auth: true,
      });
    }
  },
  investorProposal: {
    tableList(payload = {}) {
      return call(["admin", "sponsor", "proposal"], {
        method: "GET",
        auth: true,
        params: payload,
      });
    },
    add(payload) {
      return call(["admin", "sponsor", "proposal"], {
        method: "POST",
        body: payload,
      });
    },
    update(payload, investorId) {
      console.log(investorId);
      return call(["admin", "sponsor", "proposal", investorId], {
        method: "PATCH",
        body: payload,
      });
    },
    allConsultant(payload) {
      return call(["admin", "sponsors", "consultant"], {
        method: "GET",
        auth: true,
        params: payload,
        // params: { export: false },
      });
    },
    allInvestors() {
      return call(["admin", "investor"], {
        method: "GET",
        auth: true,
        // params: { export: false },
      });
    },
    delete(investorId) {
      return call(["admin", "sponsor", "proposal", investorId], {
        method: "DELETE",
        auth: true,
      });
    },
    lookups(props) {
      let params = { docNo: props };
      return call(["admin", "sponsors","proposal","lookup"], {
        method: "GET",
        auth: true,
        params,
      });
    },
    fileUpload(payload) {
      console.log(payload);
      return call(["admin", "file-upload"], {
        method: "POST",
        auth: true,
        body: { file: payload },
      });
    },
    proposals(params) {
      return call(["admin","investor","proposal","all"],{
        method: "GET",
        auth: true,
        params
      });
    },
  },
  impactProposal: {
    // tableList(payload = {}) {
    //   return call(["admin", "investor", "proposal"], {
    //     method: "GET",
    //     auth: true,
    //     params: payload,
    //   });
    // },
    add(payload) {
      return call(["admin", "investor", "impact-proposal"], {
        method: "POST",
        body: payload,
      });
    },
    update(payload, investorId) {
      return call(["admin", "investor", "impact-proposal", investorId], {
        method: "PATCH",
        body: payload,
      });
    },
    allInvestors() {
      return call(["admin", "investor"], {
        method: "GET",
        auth: true,
        // params: { export: false },
      });
    },
    delete(investorId) {
      return call(["admin", "investor", investorId], {
        method: "DELETE",
        auth: true,
      });
    },
    lookups(props) {
      let params = { docNumber: props };
      return call(["admin", "investor", "lookup"], {
        method: "GET",
        auth: true,
        params,
      });
    },
    fileUpload(payload) {
      console.log(payload);
      return call(["admin", "file-upload"], {
        method: "POST",
        auth: true,
        body: { file: payload },
      });
    },
  },
};
export const fileUpload = (formData) => {
  const headers = new Headers();
  headers.append("Authorization", `Bearer ${getUserAuthToken()}`);
  // headers.append("Content-Type", "multipart/form-data");

  const options = {
    method: "POST",
    headers: headers,
    body: formData,
  };
  const url = API_URL + "/admin/file-upload";

  return fetch(url, options)
    .then((response) => response.json()) // Parse response as JSON
    .then((data) => data) // Return the data directly
    .catch((error) => {
      // Handle the error
      console.error(error);
    });
};
